import { digitGroup, thumbor } from 'src/helpers'
import { customerCompanyTypeOptions } from '../data'

const invoiceNumberColumn = ({ sortable = true, name = 'invoiceNo', ...props } = {}) => {
  return {
    name,
    field: (row) => {
      if (!row.invoice_no) return '-'
      return `
        <a href="/invoice/detail/${row.id}/${encodeURIComponent(row.invoice_no)}" class="goto-preview-page block">
          <strong class="text-primary">${row.invoice_no}</strong>
        </a>
      `
    },
    label: 'No. Invoice',
    align: 'left',
    rowClass: 'vertical-middle',
    columnFilter: {
      type: 'SEARCH',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-search.svg'),
      sortable
    },
    ...props
  }
}

const digitalInvoiceColumn = ({ sortable = true, name = 'isDigitalInvoice', ...props } = {}) => {
  return {
    name,
    field: (row) => {
      if (row.is_digital_invoice) {
        return `
          <div class="custom-badge-square custom-badge-blue">
            Digital Invoice
          </div>
        `
      }

      return `
        <div class="custom-badge-square custom-badge-red">
          Manual
        </div>
      `
    },
    label: 'Digital Invoice',
    align: 'center',
    rowClass: 'vertical-middle text-center',
    columnFilter: {
      type: 'CHECKBOX',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
      sortable
    },
    ...props
  }
}

const ppnColumn = ({ sortable = true, name = 'isPpn', ...props } = {}) => {
  return {
    name,
    field: row => {
      if (row.is_ppn) {
        return `
          <div class="custom-badge-square custom-badge-blue">
            Dikenakan PPN
          </div>
        `
      }

      return `
        <div class="custom-badge-square custom-badge-green">
          Dibebaskan PPN
        </div>
      `
    },
    label: 'PPN',
    align: 'center',
    rowClass: 'vertical-middle text-center',
    columnFilter: {
      type: 'CHECKBOX',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
      sortable
    },
    ...props
  }
}

const customerColumn = ({ sortable = true, name = 'customerCompanyName', ...props } = {}) => {
  return {
    name,
    field: (row) => {
      const companyType = customerCompanyTypeOptions.find((c) => c.value === (row?.customer_type || row?.type))
      return `
        <div class="column gap-1">
          <strong>${row?.customer_company_name || row?.company_name || '-'}</strong>
          ${companyType?.label || '-'}
        </div>
      `
    },
    label: 'Customer',
    align: 'left',
    columnFilter: {
      type: 'SEARCH',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-search.svg'),
      sortable
    },
    style: 'max-width: 250px; word-break: break-word;',
    ...props
  }
}

const totalPriceColumn = ({ sortable = true, name = 'totalPrice', ...props } = {}) => {
  return {
    name,
    field: 'total_price',
    label: 'Nilai Tagihan',
    align: 'right',
    rowClass: 'text-right text-no-wrap vertical-middle',
    sortable,
    inRupiah: true,
    ...props
  }
}

const bnplPaymentColumn = ({ sortable = true, name = 'bnplPartnerId', ...props } = {}) => {
  return {
    name,
    field: row => {
      return `
        <div class="flex gap-3 items-center">
          <img
            src="${
              row.bnpl_id
                ? thumbor({ url: row?.bnpl_image, width: 96, height: 96, quality: 50 })
                : require('src/assets/images/icons/so/tunai-icon.svg')
            }"
            class="${row.bnpl_id ? 'border-termin' : 'border-tunai'}"
            width="24px"
            height="24px"
            alt=""
            style="
              border-radius: 9999px;
              object-fit: cover;
            "
          />
          <span>
            ${row.bnpl_id ? row.bnpl_name : 'Tunai'}
          </span>
        </div>
      `
    },
    label: 'Pembayaran',
    align: 'left',
    rowClass: 'vertical-middle text-center',
    columnFilter: {
      type: 'CHECKBOX',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
      sortable
    },
    ...props
  }
}

const ttfNumberColumn = ({ sortable = true, name = 'exchangeInvoiceNo', ...props } = {}) => {
  return {
    name,
    field: (row) => {
      return `
        <div class="column gap-1">
          <strong>${row?.exchange_invoice_no || '-'}</strong>
        </div>
      `
    },
    label: 'No. TTF',
    align: 'left',
    rowClass: 'vertical-middle',
    columnFilter: {
      type: 'SEARCH',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-search.svg'),
      sortable
    },
    ...props
  }
}

const invoiceTFDateColumn = ({ sortable = true, name = 'invoiceExchangeAt', ...props } = {}) => {
  return {
    name,
    field: 'invoice_exchange_at',
    label: 'Tgl. Invoice TF',
    align: 'left',
    commonDate: true,
    columnFilter: {
      type: 'DATE_RANGE',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-calendar.svg'),
      sortable
    },
    ...props
  }
}

const overdueDateColumn = ({ sortable = true, name = 'overdueDate', ...props } = {}) => {
  return {
    name,
    field: 'overdue_date',
    label: 'Tgl. Jatuh Tempo',
    align: 'left',
    commonDate: true,
    columnFilter: {
      type: 'DATE_RANGE',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-calendar.svg'),
      sortable
    },
    ...props
  }
}

const amountPaymentColumn = ({ sortable = true, name = 'amountPayment', ...props } = {}) => {
  return {
    name,
    field: 'amount_payment',
    label: 'Dibayar',
    align: 'right',
    rowClass: 'text-right text-no-wrap vertical-middle text-primary',
    sortable,
    inRupiah: true,
    ...props
  }
}

const amountAdjustmentColumn = ({ sortable = true, name = 'amountAdjustment', ...props } = {}) => {
  return {
    name,
    field: 'amount_adjustment',
    label: 'Adjustment',
    align: 'right',
    rowClass: 'text-right text-no-wrap vertical-middle',
    sortable,
    inRupiah: true,
    ...props
  }
}

const topColumn = ({ sortable = true, name = 'terminDays', ...props } = {}) => {
  return {
    name,
    field: row => {
      return `<div class="small">
        ${row.termin_day + ' Hari'}
      </div>`
    },
    label: 'TOP',
    rowClass: 'vertical-middle',
    columnFilter: {
      type: 'CHECKBOX',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
      sortable
    },
    align: 'left',
    ...props
  }
}

const invoiceCreatedDateColumn = ({ sortable = true, name = 'createdAt', ...props } = {}) => {
  return {
    name,
    field: 'created_at',
    label: 'Tgl. Invoice Dibuat',
    commonDate: true,
    align: 'left',
    rowClass: 'text-bold td-width-small',
    columnFilter: {
      type: 'DATE_RANGE',
      class: 'color-filter-disabled',
      icon: require('src/assets/images/icons/16x16-calendar.svg'),
      sortable
    },
    ...props
  }
}

export const invoiceListTableAll = {
  columns: [
    {
      name: 'invoice_no',
      field: (row) => {
        if (!row.invoice_no) return '-'

        let imgSend = '', badge = ''
        if (row.draft) {
          badge = '<div class="custom-badge-purple">Draf</div>'
        } else {
          imgSend = `<img src="${require('src/assets/images/icons/send-2.svg')}" alt="icon">`
          if (row.confirmation_type === 'MANUAL') badge = '<div class="custom-badge-yellow">Manual</div>'
        }
        const invoiceLink = `<a
          href="/invoice/detail/${row.id}/${encodeURIComponent(row.invoice_no)}"
          class="goto-preview-page flex gap-2 no-wrap"
        >
          <strong>${row.invoice_no}</strong>
          ${imgSend}
        </a>`

        return invoiceLink + badge
      },
      label: 'No. Invoice',
      align: 'left',
      rowClass: 'text-primary text-weight-bold',
      sortable: true
    },
    {
      name: 'so_no',
      field: (row) => {
        return row.so_no
          ? `<a href="/so/detail/${row.so_id}/${encodeURIComponent(
              row.so_no
            )}" class="goto-preview-page">
          <strong class="text-primary">${row.so_no}</strong>
        </a>
        <div class="text-caption text-grey">${row.so_no_cust || '-'}</div>`
          : '-'
      },
      label: 'No. Sales Order',
      align: 'left',
      sortable: true
    },
    {
      name: 'customer',
      field: (row) => {
        return row.customer_name
          ? `${row.customer_name}
            <div class="text-caption text-grey">
            ${
              {
                PROJECT_OWNER: 'Pemilik Proyek',
                ARCHITECT: 'Arsitek',
                DEVELOPER: 'Developer',
                CONTRACTOR: 'Kontraktor',
                OTHER: 'Lainnya'
              }[row?.customer_type] || '-'
            }
            </div>`
          : '-'
      },
      label: 'Customer',
      align: 'left',
      sortable: true
    },
    {
      name: 'payment_type',
      field: (row) => {
        return row.payment_type
          ? `
          <div>
          ${
            {
              TRANSFER: 'Tunai',
              TUNAI: 'Tunai',
              VIRTUAL_ACCOUNT: 'Tunai',
              DOKU: 'Tunai',
              TERMIN: 'Tempo',
              TEMPO: 'Tempo',
              JM_PAYLATER: 'Tempo',
              PAPER_PAYLATER: 'Tempo'
            }[row.payment_type] || '-'
          }
        </div>
        <div class="small text-grey-6">
        ${
          {
            TRANSFER: 'Transfer Manual',
            TUNAI: 'Transfer Manual',
            VIRTUAL_ACCOUNT: 'Virtual Account',
            DOKU: 'Paylater',
            PAPER_PAYLATER: 'Paylater',
            JM_PAYLATER: row.days && !!row.days ? row.payment_code : '-',
            TEMPO: row.days && !!row.days ? row.days + ' Hari' : ''
          }[row.payment_type] || ''
        }
      </div>`
          : '-'
      },
      label: 'Pembayaran',
      align: 'left',
      sortable: true
    },
    {
      name: 'total_price',
      field: (row) => {
        return `Rp ${digitGroup(row.total_price)}`
      },
      label: 'Nilai Tagihan',
      align: 'right',
      rowClass: 'text-right text-no-wrap',
      sortable: true
    },
    {
      name: 'document',
      field: (row) => {
        return `
        ${
          row.sign && !!row.sign
            ? '<div class="custom-badge-green">TTD</div>'
            : ''
        }

          ${
            row.stamp && !!row.stamp
              ? '<div class="custom-badge-blue q-my-xs">Materai</div>'
              : ''
          }

          ${
            row.tax_invoice && !!row.tax_invoice
              ? '<div class="custom-badge-yellow">FP</div>'
              : ''
          }
        `
      },
      label: 'Kelengkapan',
      align: 'left',
      sortable: true
    },
    {
      name: 'status',
      field: (row) => {
        return (
          {
            NON_CONFIRMED:
              '<div class="custom-badge-lilac">Belum Dikonfirmasi</div>',
            CONFIRMED:
              '<div class="custom-badge-blue">Sudah Dikonfirmasi</div>',
            REJECTED: '<div class="custom-badge-red">Ditolak</div>',
            PAYMENT: '<div class="custom-badge-green">Pembayaran</div>'
          }[row.status] || '-'
        )
      },
      label: 'Status',
      align: 'left',
      sortable: true
    }
  ]
}

export const invoiceListTableNonMade = {
  columns: [
    {
      name: 'doNo',
      field: (row) => {
        return `
          <a href="/do/detail/${row.id}/${encodeURIComponent(row.do_no)}" class="goto-preview-page block">
            <strong class="text-primary">${row.do_no}</strong>
          </a>`
      },
      label: 'No. Delivery Order',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg')
      }
    },
    customerColumn({ name: 'companyName' }),
    {
      name: 'sendingAt',
      field: 'sending_at',
      label: 'Tgl. Barang Diterima',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    digitalInvoiceColumn(),
    totalPriceColumn({ name: 'priceTotal', field: 'price_total' })
  ]
}

export const invoiceListTableFinishFP = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    {
      name: 'approvedTaxAt',
      field: 'approved_tax_at',
      label: 'Tgl. FP Diapprove',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    digitalInvoiceColumn({ sortable: false }),
    ppnColumn({ sortable: false }),
    totalPriceColumn({ sortable: false }),
    {
      name: 'invoiceMergeStatus',
      field: (row) => {
        if (row.invoice_merge_status === 'success') {
          return `
            <div class="custom-badge-square custom-badge-green">
              Sudah Digabung
            </div>
          `
        }

        return `
          <div class="custom-badge-square custom-badge-red">
            Belum Digabung
          </div>
        `
      },
      label: 'Status Dokumen',
      align: 'center',
      rowClass: 'vertical-middle text-center'
    }
  ]
}

export const invoiceListTableMade = {
  columns: [
    invoiceNumberColumn({ sortable: false, name: 'invoice_no' }),
    customerColumn({ sortable: false, name: 'customer_company_name' }),
    invoiceCreatedDateColumn({ sortable: false }),
    digitalInvoiceColumn({ sortable: false, name: 'is_digital_invoice' }),
    ppnColumn({ sortable: false, name: 'is_ppn' }),
    totalPriceColumn({ sortable: false, name: 'total_price' })
  ]
}

export const invoiceListTableProcessFp = {
  columns: [
    invoiceNumberColumn({ sortable: false, name: 'invoice_no' }),
    customerColumn({ sortable: false, name: 'customer_company_name' }),
    {
      name: 'createdAt',
      field: 'created_at',
      label: 'Tgl. FP Diproses',
      commonDate: true,
      align: 'left',
      rowClass: 'text-bold td-width-small',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    digitalInvoiceColumn({ sortable: false, name: 'is_digital_invoice' }),
    ppnColumn({ sortable: false, name: 'is_ppn' }),
    totalPriceColumn({ sortable: false, name: 'total_price' })
  ]
}

export const invoiceListTableProcessTTF = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    {
      name: 'approveTtfAt',
      field: 'approve_ttf_at',
      label: 'Tgl. Selesai Review',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg')
      }
    },
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTableOnReview = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    {
      name: 'reviewedInvoiceAt',
      field: 'reviewed_invoice_at',
      label: 'Tgl. Direview',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    digitalInvoiceColumn({ sortable: false }),
    ppnColumn({ sortable: false }),
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTableSent = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    {
      name: 'sendingAt',
      field: 'sending_at',
      label: 'Tgl. Invoice Terkirim',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    bnplPaymentColumn({ sortable: false }),
    digitalInvoiceColumn({ sortable: false }),
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTableReadySend = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    ttfNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    {
      name: 'ttfCreatedAt',
      field: 'ttf_created_at',
      label: 'Tgl. TTF',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTablePartiallyPaid = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    invoiceTFDateColumn({ sortable: false }),
    overdueDateColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    totalPriceColumn({ sortable: false }),
    amountPaymentColumn({ sortable: false }),
    {
      name: 'amountOutstanding',
      field: 'amount_outstanding',
      label: 'Outstanding',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle text-negative',
      sortable: false,
      inRupiah: true
    },
    amountAdjustmentColumn({ sortable: false })
  ]
}

export const invoiceListTableFinished = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    invoiceTFDateColumn({ sortable: false }),
    overdueDateColumn({ sortable: false }),
    {
      name: 'finishedAt',
      field: 'finished_at',
      label: 'Tgl. Selesai',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    totalPriceColumn({ sortable: false }),
    amountPaymentColumn({ sortable: false }),
    amountAdjustmentColumn({ sortable: false })
  ]
}

export const invoiceListTableFinishTTF = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    invoiceTFDateColumn({ sortable: false }),
    bnplPaymentColumn({ sortable: false }),
    topColumn({ sortable: false }),
    overdueDateColumn({ sortable: false }),
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTablePaid = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    invoiceTFDateColumn({ sortable: false }),
    overdueDateColumn({ sortable: false }),
    totalPriceColumn({ sortable: false }),
    amountPaymentColumn({ sortable: false }),
    amountAdjustmentColumn({ sortable: false })
  ]
}

export const invoiceListTableNotPaid = {
  columns: [
    invoiceNumberColumn({ sortable: false }),
    customerColumn({ sortable: false }),
    invoiceCreatedDateColumn({ sortable: false }),
    totalPriceColumn({ sortable: false })
  ]
}

export const invoiceListTableMonitoringAr = {
  columns: [
    customerColumn({ sortable: false }),
    {
      name: 'soNo',
      field: (row) => {
        return `
          <a href="/so/detail/${row.so_id}/${encodeURIComponent(row.so_no)}" class="goto-preview-page block">
            <strong class="text-primary">${row?.so_no || '-'}</strong>
          </a>`
      },
      label: 'No. Sales Order',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    {
      name: 'doNo',
      field: (row) => {
        return `
          <a href="/do/detail/${row.do_id}/${encodeURIComponent(row.do_no)}" class="goto-preview-page block">
            <strong class="text-primary">${row?.do_no || '-'}</strong>
          </a>`
      },
      label: 'No. Delivery Order',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    {
      name: 'doSentAt',
      field: 'do_sent_at',
      label: 'DO Sent Date',
      align: 'left',
      commonDate: true,
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'returnLetterAt',
      field: 'return_letter_at',
      label: 'DO SJ Balik Date',
      align: 'left',
      commonDate: true,
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'invoiceNo',
      field: (row) => {
        if (!row.invoice_no) return '-'
        return `
        <a href="/invoice/detail/${row.invoice_id}/${encodeURIComponent(row.invoice_no)}" class="goto-preview-page block">
          <strong class="text-primary">${row.invoice_no}</strong>
        </a>
      `
      },
      label: 'No. Invoice',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    bnplPaymentColumn({ sortable: false, label: 'ID BNPL' }),
    digitalInvoiceColumn({ sortable: false }),
    {
      name: 'taxInvoiceNumber',
      field: (row) => {
        return `
          <div class="column gap-1">
            <strong>${row?.tax_invoice_number || '-'}</strong>
          </div>
        `
      },
      label: 'No. Faktur Pajak',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    {
      name: 'ttfNo',
      field: (row) => {
        return `
          <div class="column gap-1">
            <strong>${row?.ttf_no || '-'}</strong>
          </div>
        `
      },
      label: 'No. TTF',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    {
      name: 'invoiceCreatedAt',
      field: 'invoice_created_at',
      label: 'Invoice Created Date',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'processableTaxAt',
      field: 'processable_tax_at',
      label: 'Process FP Date',
      commonDate: true,
      align: 'left',
      rowClass: 'text-bold td-width-small vertical-middle',
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'finishedFpAt',
      field: 'finished_fp_at',
      label: 'Finish FP Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'reviewedInvoiceAt',
      field: 'reviewed_invoice_at',
      label: 'Reviewed Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'approveTtfAt',
      field: 'approve_ttf_at',
      label: 'Approved Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'ttfCreatedAt',
      field: 'ttf_created_at',
      label: 'TTF Created Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'sendingAt',
      field: 'sending_at',
      label: 'Send Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'invoiceExchangeAt',
      field: 'invoice_exchange_at',
      label: 'Done TF Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'picExchangeInvoice',
      field: (row) => {
        return `
          <div class="column gap-1">
            <strong>${row?.pic_exchange_invoice || '-'}</strong>
          </div>
        `
      },
      label: 'PIC TF Juragan to Customer',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'SEARCH',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-search.svg'),
        sortable: false
      }
    },
    {
      name: 'so_amount',
      field: 'so_amount',
      label: 'SO Amount',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'invoice_amount',
      field: 'invoice_amount',
      label: 'Invoice Amount',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'dueDate',
      field: 'due_date',
      label: 'Due Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'amount_outstanding',
      field: 'amount_outstanding',
      label: 'Outstanding',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_15_days_after_selected_date',
      field: 'outstanding_15_days_after_selected_date',
      label: '< -15 From Due Date',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_15_days_selected_date',
      field: 'outstanding_15_days_selected_date',
      label: '-15 From Due Date',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'not_yet_due',
      field: 'not_yet_due',
      label: 'Not Yet Due',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_until_next_1_to_15_days',
      field: 'outstanding_until_next_1_to_15_days',
      label: '1-15',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_until_next_16_to_30_days',
      field: 'outstanding_until_next_16_to_30_days',
      label: '16-30',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_until_next_31_to_60_days',
      field: 'outstanding_until_next_31_to_60_days',
      label: '31-60',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_until_next_61_to_90_days',
      field: 'outstanding_until_next_61_to_90_days',
      label: '61-90',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'outstanding_until_more_than_90_days',
      field: 'outstanding_until_more_than_90_days',
      label: '90+',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'is_provisi',
      field: (row) => {
        return `
          <div class="column gap-1">
            <p>${row?.is_provisi === null ? '-' : row?.is_provisi ? 'TRUE' : 'FALSE'}</p>
          </div>
        `
      },
      label: 'Provisi',
      align: 'left',
      rowClass: 'vertical-middle',
      sortable: false
    },
    {
      name: 'paymentDate',
      field: 'payment_date',
      label: 'Payment Date',
      align: 'left',
      rowClass: 'vertical-middle',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    {
      name: 'finishedInvoiceAt',
      field: 'finished_invoice_at',
      label: 'Finish Date',
      rowClass: 'vertical-middle',
      align: 'left',
      commonDate: true,
      columnFilter: {
        type: 'DATE_RANGE',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-calendar.svg'),
        sortable: false
      }
    },
    amountPaymentColumn({ sortable: false, label: 'Amount of Payment' }),
    {
      name: 'amount_adjustment',
      field: 'amount_adjustment',
      label: 'Adjustment',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'customer_deposito',
      field: 'customer_deposito',
      label: 'Customer Deposit',
      align: 'right',
      rowClass: 'text-right text-no-wrap vertical-middle',
      sortable: false,
      inRupiah: true
    },
    {
      name: 'referalCode',
      field: 'referal_code',
      label: 'Sales',
      align: 'left',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
        sortable: false
      }
    },
    {
      name: 'top',
      field: row => {
        return row.top
          ? `<div class="small">
          ${row.top + ' Hari'}
        </div>`
          : '-'
      },
      label: 'TOP',
      rowClass: 'vertical-middle',
      columnFilter: {
        type: 'CHECKBOX',
        class: 'color-filter-disabled',
        icon: require('src/assets/images/icons/16x16-chevron-down.svg'),
        sortable: false
      },
      align: 'left'
    },
    {
      name: 'payment_days',
      field: row => {
        return row.payment_days
          ? `<div class="small">
          ${row.payment_days}
        </div>`
          : '-'
      },
      label: 'Payment Days',
      align: 'left',
      rowClass: 'vertical-middle'
    }
  ]
}
